import { Map } from 'immutable'

const locales = {
  default: require('./locales/en_us').default,
  en_us: require('./locales/en_us').default,
  en_gb: require('./locales/en_us').default,
  en_ie: require('./locales/en_us').default,
  ru: require('./locales/ru').default,
  ru_ru: require('./locales/ru').default,
  ro: require('./locales/ro').default,
  ro_ro: require('./locales/ro').default,
  ua: require('./locales/ua').default,
  uk_ua: require('./locales/ua').default,
  fr: require('./locales/fr').default,
  fr_fr: require('./locales/fr').default,
  fr_ca: require('./locales/fr').default,
  es: require('./locales/sp').default,
  es_mx: require('./locales/sp').default,
  es_us: require('./locales/sp').default,
  es_es: require('./locales/sp').default,
  de: require('./locales/de').default,
  de_de: require('./locales/de').default,
  da: require('./locales/da').default,
  da_da: require('./locales/da').default,
  da_dk: require('./locales/da').default,
  it: require('./locales/it').default,
  it_it: require('./locales/it').default,
  pt_br: require('./locales/pt_br').default,
  pt_pt: require('./locales/pt_br').default,
  pt: require('./locales/pt').default,
  tr: require('./locales/tr').default,
  tr_tr: require('./locales/tr').default,
  th: require('./locales/th').default,
  th_th: require('./locales/th').default,
  zh_cn: require('./locales/zh_cn').default,
  zh_sg: require('./locales/zh_cn').default,
  zh_tw: require('./locales/zh_tw').default,
  zh_hk: require('./locales/zh_hk').default,
  ko: require('./locales/ko').default,
  ko_kr: require('./locales/ko').default,
  ja: require('./locales/ja').default,
  ja_jp: require('./locales/ja').default,
  hi: require('./locales/hi').default,
  hi_in: require('./locales/hi').default,
  id: require('./locales/id').default,
  id_id: require('./locales/id').default,
  pl: require('./locales/pl').default,
  pl_pl: require('./locales/pl').default,
  sv: require('./locales/sv').default,
  sv_se: require('./locales/sv').default,
  nl: require('./locales/nl').default,
  nl_nl: require('./locales/nl').default,
  ar: require('./locales/ar').default,
  ar_ae: require('./locales/ar').default,
  he: require('./locales/he').default,
  he_il: require('./locales/he').default,
  gr: require('./locales/gr').default,
  el_gr: require('./locales/gr').default,
  no_no: require('./locales/nor').default,
  nor: require('./locales/nor').default,
  bg: require('./locales/bg').default,
  bg_bg: require('./locales/bg').default,
  vi: require('./locales/vi').default,
  vi_vi: require('./locales/vi').default,
  vi_vn: require('./locales/vi').default,
  ma: require('./locales/ma').default,
  ms_ma: require('./locales/ma').default,
  ms_my: require('./locales/ma').default,
  fi: require('./locales/fi').default,
  fi_fi: require('./locales/fi').default
}

export default function locale(locale = 'en_us') {
  return 'en_us' == locale
    ? locales.default
    : locales.default
        .mergeDeep(locales[locale.toLowerCase().slice(0, 2)] || Map())
        .mergeDeep(locales[locale.toLowerCase()] || Map())
}
